export const employees: string[] = [
  'axel',
  'amanda',
  'emin',
  'frida',
  'jonatan.jonsson',
  'kevin.kimaryo',
  'love.malmros',
  'niklas.hellgren',
  'rasmus.c',
  'rasmus.persson'
]

export const avatarImages: Record<string, string> = {
  ['axel']:
    'https://images.ctfassets.net/1k6n64mfastn/57px9PWIJXzFEISi3ErApq/e8b5817f8f01e36a01249b124ec63c59/Axel__1_1__transparent_.png',
  ['amanda']:
    'https://images.ctfassets.net/1k6n64mfastn/6yEbm2pAI6mMKaHjWqkLOK/3d3b77524480ba90b2f5aeaef890290f/Amanda__1_1__transparent_.png',
  ['emin']:
    'https://images.ctfassets.net/1k6n64mfastn/7qBmGKHd5A8jLvFJhgy1y/ac96e768048efa3f04db75736d36bc4a/Emin_Karaman.png',
  ['frida']:
    'https://images.ctfassets.net/1k6n64mfastn/4BOljU1Pjg1oxauNapCRqK/17b05a66823764e066003bf3e391b8cb/Frida__1_1__transparent_.png',
  ['jonatan.jonsson']:
    'https://images.ctfassets.net/1k6n64mfastn/2Z6bqjbfXBKHNdANOzKIGF/03a509163332972d51cf712811d07a32/Jonatan__1_1__transparent_.png',
  ['kevin.kimaryo']:
    'https://images.ctfassets.net/1k6n64mfastn/xAbYYiuYIqEzLVzP8kjgD/c7c5f2ff6df4583b6cd42c2a76e8d806/Kevin__1_1__transparent_.png',
  ['love.malmros']:
    'https://images.ctfassets.net/1k6n64mfastn/7fMeWKVmMi6QB4D1pT5auG/97c487ef97ac0714934c7ff204386993/Love__1_1__transparent_.png',
  ['niklas.hellgren']:
    'https://images.ctfassets.net/1k6n64mfastn/2G83C2y30k8pzjkU7Tr7me/50336ed9c70b8f62506bc218b4da7a4a/Niklas__1_1__transparent_.png',
  ['rasmus.c']:
    'https://images.ctfassets.net/1k6n64mfastn/6yOC6isMFRTKz9m34ej9Vl/bc5afe1d2b5a4f0c0b45ccff85f22abf/Rasmus_Comstedt.png',
  ['rasmus.persson']:
    'https://images.ctfassets.net/1k6n64mfastn/3YFJe9FyGlGNGDWjrbzzB0/0a4f8b27cc23336a2c99b5580f08a4d9/Rasmus__1_1__transparent_.png'
}
